import React, {useEffect, useState} from 'react';

interface ProductImagesPreviewProps {
  images: File[];
  onRemove: (index: number) => void;
}

const ProductImagesPreview: React.FC<ProductImagesPreviewProps> = ({images, onRemove}) => {
  const [previews, setPreviews] = useState<string[]>([]);

  useEffect(() => {
    console.log('ProductImagesPreview - images received:', images);
    previews.forEach(url => URL.revokeObjectURL(url));
    const newPreviews = images.map(img => URL.createObjectURL(img));
    console.log('ProductImagesPreview - created preview URLs:', newPreviews);
    setPreviews(newPreviews);
    // eslint-disable-next-line
  }, [images]);

  if (!images.length) {return null;}

  return (
    <div className="flex gap-2 mt-2 flex-wrap">
      {images.map((img, i) => (
        <div key={i} className="relative group">
          <img
            src={previews[i]}
            alt={img.name}
            className="w-14 h-14 object-cover rounded-lg border border-gray-200"
          />
          <button
            type="button"
            className="absolute -top-2 -left-2 w-6 h-6 flex items-center justify-center rounded-full bg-white border border-gray-300 text-xs text-gray-500 hover:text-red-500 hover:bg-red-50 transition opacity-0 group-hover:opacity-100"
            onClick={() => onRemove(i)}
            aria-label="حذف الصورة"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
};

export default ProductImagesPreview;
